// Single source of truth for Ponesi's legal operator details (used by Contact + legal pages).
export const LEGAL = {
  entity: "Sahara Group DOO",
  addressLines: ["Masarikov Trg 18", "16000 Leskovac"],
  countrySr: "Republika Srbija",
  countryEn: "Republic of Serbia",
  pib: "115572837",
  mb: "22177460",
  email: "privacy@ponesi.rs",
  web: "ponesi.rs",
};
